import React from 'react';
import { WebSocketContext } from '../components/WebsocketContext/WebsocketContext';

export const useWebSocketContext = () => {
    return React.useContext(WebSocketContext);
};
